import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { DealSubmitRequestInput } from "@colab/shared";

// POST /api/portal/deals
//
// Phase 7 sub-bucket 5 — partner submits a new lead.
//
// Pessimistic (bucket-10 invariant for state transitions). Returns the new
// deal id; the caller navigates to `/portal/deals/${id}` on success.
//
// Replaces /app/portal/forms/deal-registration as a dedicated lead-entry
// surface for the SPA. The legacy form-based path remains live until the
// Phase 7 portal-forms cutover completes.
export function useSubmitDeal() {
  const queryClient = useQueryClient();
  return useMutation<{ id: string }, ApiClientError, DealSubmitRequestInput>({
    mutationFn: (body) =>
      apiFetch<{ id: string }>("/portal/deals", {
        method: "POST",
        body: JSON.stringify(body),
      }),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: queryKeys.portal.deals.list(),
      });
      void queryClient.invalidateQueries({
        queryKey: queryKeys.portal.dealSummary(),
      });
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to submit deal");
    },
  });
}
